export default "__VITE_ASSET__tGX1Ymbk__"